import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { ServiceTypePickerItem } from './service-type-picker-item';
import { ServiceTypePickerService } from './service-type-picker.service';

@Component({
  selector: 'pop-service-type-picker',
  templateUrl: './service-type-picker.component.html'
})
export class ServiceTypePickerComponent extends BaseComponent implements OnInit {
  @Input() public readonly = false;
  @Input() public styleClass: 'rem-fix' | '' = '';

  public allServiceTypes: ServiceTypePickerItem[];
  public serviceTypes: ServiceTypePickerItem[];

  private _selectedServiceType: ServiceTypePickerItem;
  @Input() public get selectedServiceType() {
    return this._selectedServiceType;
  }
  public set selectedServiceType(value: ServiceTypePickerItem) {
    if (value === null) value = undefined;
    if (this._selectedServiceType !== value) {
      this._selectedServiceType = value;
      this.selectedServiceTypeChange.emit(value);
    }
  }

  private _serviceTypeFilter: (serviceType: ServiceTypePickerItem) => boolean;
  @Input() public get serviceTypeFilter() {
    return this._serviceTypeFilter;
  }
  public set serviceTypeFilter(value: (serviceType: ServiceTypePickerItem) => boolean) {
    this._serviceTypeFilter = value;
    this.filter();
  }

  @Output() public selectedServiceTypeChange = new EventEmitter<ServiceTypePickerItem | undefined>();

  public constructor(private serviceTypePickerService: ServiceTypePickerService) {
    super();
  }

  public async ngOnInit() {
    const serviceTypes = await this.serviceTypePickerService.getServiceTypes();

    this.allServiceTypes = serviceTypes.map(st => {
      return new ServiceTypePickerItem(st); // avoid stackoverflow in prime ng equals by value
    });

    this.filter();
  }

  private filter() {
    if (this.serviceTypeFilter) {
      this.serviceTypes = this.allServiceTypes?.filter(st => {
        return this.serviceTypeFilter(st);
      });
    } else {
      this.serviceTypes = this.allServiceTypes;
    }
  }
}
